import Vue from "vue";
import Router from "vue-router";
import FkMisstanktForsteg from "@/views/FkMisstanktForsteg.vue";
import FkAnmalan from "@/views/FkAnmalan.vue";
import FkKvittens from "@/views/FkKvittens.vue";
import { focus } from "@fkui/logic";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "/",
            redirect: "/forsteg",
        },
        {
            path: "/forsteg",
            name: "FkMisstanktForsteg",
            component: FkMisstanktForsteg,
        },
        {
            path: "/anmalan",
            name: "FkAnmalan",
            component: FkAnmalan,
        },
        {
            path: "/kvittens",
            name: "FkKvittens",
            component: FkKvittens,
        },
    ],
});

/* move focus to first heading after route change */
let first = true;
router.afterEach(() => {
    if (first) {
        first = false;
        return;
    }

    /* skip to next cycle to allow view to be rendered */
    setTimeout(() => {
        const main = document.querySelector("main");
        if (main) {
            const heading = main.querySelectorAll("h1");
            if (heading && heading.length > 0) {
                heading[0].setAttribute("tabindex", "-1");
                focus(heading[0]);
            } else {
                /* utifall det inte finns nån h1 inom main */
                focus(main);
            }
        }
    });
});

export default router;
